import { selectRow, selectRowByRowIndex } from '@client-shared/ui-agGrid';

import {
  FETCH_BUSINESS_UNITS,
  FETCH_BUSINESS_UNITS_SUCCESS,
  FETCH_BUSINESS_UNITS_FAILURE,
  FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL,
  FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_FAILURE,
  SAVING_BUSINESS_UNIT,
  SAVING_BUSINESS_UNIT_SUCCESS,
  SAVING_BUSINESS_UNIT_FAILURE,
  SAVING_BUSINESS,
  SAVING_BUSINESS_SUCCESS,
  SAVING_BUSINESS_FAILURE,
} from './types';
import {
  fetchBusinessUnits as fetchBusinessUnitsApi,
  fetchEnabledFlagValues as fetchEnabledFlagValuesApi,
  fetchBusinessCodes as fetchBusinessCodesApi,
  addBusinessUnit as addBusinessUnitApi,
  updateBusinessUnit as updateBusinessUnitApi,
  deleteBusinessUnit as deleteBusinessUnitApi,
  addBusinessCode as addBusinessCodeApi,
} from '../api';
import { selectPeriod, fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import ModalNames from '../modalNames';
import getModalActions from '../../../shared/modals/getModalActions';

import agGridConfig from '../../../agGridConfig';

const fetchBusinessUnits = period => async dispatch => {
  dispatch({
    type: FETCH_BUSINESS_UNITS,
  });

  try {
    const response = await fetchBusinessUnitsApi(period.name);

    return dispatch({
      type: FETCH_BUSINESS_UNITS_SUCCESS,
      businessUnits: response,
    });
  } catch (error) {
    dispatch({
      type: FETCH_BUSINESS_UNITS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const fetchInitialDataForBusinessUnitSettings = period => async dispatch => (
  dispatch(fetchBusinessUnits(period))
);

export const selectPeriodForBusinessUnitSettings = period => dispatch => {
  dispatch(selectPeriod(period));

  return dispatch(fetchBusinessUnits(period));
};

const {
  showAction: showAddEditModal,
  hideAction: hideAddEditModal,
} = getModalActions(ModalNames.BusinessUnitSettingsAddAndEdit);

const {
  showAction: showDeleteModal,
  hideAction: hideDeleteModal,
} = getModalActions(ModalNames.BusinessUnitSettingsDelete);

export {
  showAddEditModal,
  hideAddEditModal,
  showDeleteModal,
  hideDeleteModal,
};

export const fetchInitialDataForBusinessUnitModal = () => async dispatch => {
  dispatch({
    type: FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL,
  });

  try {
    const [
      enabledFlagValuesResponse,
      businessCodesResponse,
    ] = await Promise.all([
      fetchEnabledFlagValuesApi(),
      fetchBusinessCodesApi(),
    ]);


    return dispatch({
      type: FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_SUCCESS,
      enabledFlagValues: enabledFlagValuesResponse,
      businessCodes: businessCodesResponse,
    });
  } catch (error) {
    dispatch({
      type: FETCH_INITIAL_DATA_FOR_BUSINESS_UNIT_MODAL_FAILURE,
    });
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const saveBusinessUnit = ({
  businessUnitData,
  period,
  leaveModalOpen,
  isEditMode,
}, callback) => async dispatch => {
  if (!period) {
    return;
  }

  dispatch({
    type: SAVING_BUSINESS_UNIT,
  });

  try {
    if (!isEditMode) {
      await addBusinessUnitApi({
        periodName: period.name,
        businessUnitData,
      });
    } else {
      await updateBusinessUnitApi({
        periodName: period.name,
        businessUnitData,
      });
    }

    if (!isEditMode) {
      dispatch(successNotification('Business Unit added'));
    } else {
      dispatch(successNotification('Business Unit updated'));
    }
    dispatch({
      type: SAVING_BUSINESS_UNIT_SUCCESS,
    });

    dispatch(selectRow({
      name: agGridConfig.adminBusinessUnitSettings.name,
      fields: agGridConfig.adminBusinessUnitSettings.fields,
      data: businessUnitData,
    }));

    await dispatch(fetchBusinessUnits(period));

    if (callback) {
      callback();
    }

    if (leaveModalOpen) {
      return;
    }

    return dispatch(hideAddEditModal());
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: SAVING_BUSINESS_UNIT_FAILURE,
      });
      return;
    }
    throw error;
  }
};

export const deleteBusinessUnit = ({ periodName, businessUnit }, { rowIndex }) => async dispatch => {
  try {
    await deleteBusinessUnitApi({
      periodName,
      businessUnit,
    });
    dispatch(successNotification('Business Unit removed'));
    dispatch(hideDeleteModal());
    dispatch(selectRowByRowIndex(rowIndex ? rowIndex - 1 : 0));
    return await dispatch(fetchBusinessUnits({ name: periodName }));
  } catch (error) {
    dispatch(errorNotification(error.message));
  }
};

export const {
  showAction: showBusinessModalForAdd,
  hideAction: hideBusinessModalForAdd,
} = getModalActions(ModalNames.BusinessAdd);

export const saveBusiness = ({ businessData }, callback ) => async dispatch => {
  dispatch({
    type: SAVING_BUSINESS,
  });

  try {
    await addBusinessCodeApi({
      businessData,
    });
    dispatch(successNotification('Business Code added'));

    dispatch({
      type: SAVING_BUSINESS_SUCCESS,
    });

    if (callback) {
      callback();
    }
    return dispatch(hideBusinessModalForAdd());
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      dispatch({
        type: SAVING_BUSINESS_FAILURE,
      });
      return;
    }
    throw error;
  }
};
